import fetchFile from "./fetchFile";
import appendix from "@common/appendix";

import GothamBook from "@public/assets/fonts/Gotham Fonts/Gotham-Book.otf";
import GothamMedium from "@public/assets/fonts/Gotham Fonts/Gotham-Medium.otf";
import GothamBold from "@public/assets/fonts/Gotham Fonts/Gotham-Bold.otf";
import GothamItalic
  from "@public/assets/fonts/Gotham Fonts/Gotham-BookItalic.otf";

/*global pdfMake b*/
/*eslint no-undef: "error"*/
class PdfTemplate {
  generateDocument(section) {
    // Set document subtitle (used in header)
    this.headerSubtitle = section.title;

    let dd = this.getBaseTemplate();
    let clientName = "";
    let clientId = "";
    //TODO: after the landing page is done,
    // store clientName and Id in the store so it can be generated here
    dd.content = dd.content.concat(
      this.generateClientInfo(clientName, clientId)
    );
    dd.content = dd.content.concat(this.generateSection(section));
    dd.content.push({
      text: `Completed By (Name/Designation): ${"_".repeat(40)}`,
      style: "subTitle",
      margin: [0, 20, 47, 0],
      alignment: "right"
    });

    dd.content.push({
      text: `Date: ${"_".repeat(40)}`,
      style: "subTitle",
      alignment: "right",
      margin: [0, 10, 47, 0]
    });

    return dd;
  }

  generateClientInfo(name, id) {
    name = name || "";
    id = id || "";
    name = name.trim();
    if (name.length > 29) {
      name = name.match(/\S{1,29}/g).join("\n");
    }
    id = id.trim();
    let emptyName = " ".repeat(496);
    let emptyId = " ".repeat(40);
    return [
      {
        text: "This tool provides practical steps to assess the risk of violence for those who work in the community, along with useful tips and guidelines to address the risk.",
        margin: [0, 10, 0, 0]
      },
      {
        columns: [
          {
            stack: [
              {
                style: "subTitle",
                text: [
                  "Client Name:    ",
                  {
                    text: name || emptyName,
                    decoration: !name ? "underline" : false,
                    decorationColor: "#888888",
                    bold: false,
                    fontSize: name ? 11 : 1
                  }
                ],
                margin: [0, 3, 0, 10]
              },
              name
                ? ""
                : {
                    style: "subTitle",
                    text: [
                      "Last Name:    ",
                      {
                        text: " ".repeat(526),
                        decoration: !name ? "underline" : false,
                        decorationColor: "#888888",
                        bold: false,
                        fontSize: 1
                      }
                    ],
                    margin: [0, 0, 0, 10]
                  },
              {
                style: "subTitle",
                text: [
                  "Identification #:    ",
                  {
                    text: id || emptyId,
                    decoration: !id ? "underline" : false,
                    decorationColor: "#888888",
                    bold: false
                  }
                ],
                margin: [0, 0, 0, 10]
              }
            ],
            width: 250,
            margin: [0, 0, 10, 0]
          },
          {
            color: "#bbbbbb",
            table: {
              widths: [246],
              body: [
                [
                  {
                    text: "Apply ID # sticker",
                    alignment: "center",
                    margin: [0, 30, 0, 30],
                    bold: true
                  }
                ]
              ]
            },
            width: 250,
            margin: [0, 0, 0, 5],
            layout: {
              hLineColor: function(i, node) {
                return "#bbbbbb";
              },
              vLineColor: function(i, node) {
                return "#bbbbbb";
              }
            }
          }
        ],
        margin: [0, 15, 0, 0]
      }
    ];
  }

  generateSection(section) {
    let ret = [];
    section.subsections.forEach((subsection, index) => {
      ret = ret.concat(this.generateSubsection(subsection));
    });
    return ret;
  }

  /**
   * Generate a table for each subsection
   * @param  {string} tableHeader   Table header
   * @param  {object} section       Section from app
   * @return {array}                Generated table
   */
  generateSubsection(section) {
    const { risks, checkedAppendixTips, comment } = section;
    const tableHeader = section.subTitle;
    const suggestedTips = section.suggestedTips.filter(tip => tip.isChecked);

    // Initiate and style the table
    let sectionTable = {
      margin: [0, 20, 0, 0],
      table: {
        widths: [438, 50],
        headerRows: tableHeader ? 2 : 1,
        body: [],
        dontBreakRows: false
      },
      layout: {
        hLineWidth: function(i, node) {
          return 1;
        },
        vLineWidth: function(i, node) {
          return 1;
        },
        hLineColor: function(i, node) {
          return "#C9C9C9";
        },
        vLineColor: function(i, node) {
          return "#C9C9C9";
        },
        fillColor: function(i, node) {
          return i < node.table.headerRows ? "#eeeeee" : "white";
        },
        paddingBottom: function(i, node) {
          return 0;
        },
        paddingTop: function(i, node) {
          return 0;
        }
      }
    };

    // Add the section table header
    if (tableHeader) {
      sectionTable.table.body.push([
        {
          text: tableHeader,
          style: "tableTitle",
          alignment: "center",
          colSpan: 2
        },
        {}
      ]);
    }

    // Add the column guides
    sectionTable.table.body.push([
      {
        text: "Risk Factor",
        style: "tableSubTitle"
      },
      {
        text: "Y/N",
        style: "tableSubTitle",
        alignment: "center"
      }
    ]);

    // Generate content
    for (let row of Object.values(risks)) {
      sectionTable.table.body.push([
        {
          info: {
            /*This is the left column, containing question, appendix tips and suggested controls*/
          },
          stack: this.generateRiskInfo(row),
          margin: [13, 10, 13, 10]
        },
        {
          info: {
            /*This is the right column, containing answer to the question */
          },
          text: this.getRiskAnswer(row.whichIsRisk, row.isRisk),
          alignment: "center",
          margin: [13, 10, 13, 10]
        }
      ]);
    }

    // Check whether the section has suggested or appendix tips
    const hasSuggestedTips = suggestedTips.length > 0;
    const hasAppendixTips =
      Object.keys(checkedAppendixTips).reduce((accum, key) => {
        return (accum += [].concat.apply([], checkedAppendixTips[key]).length);
      }, 0) > 0;

    // Create the Appendix table
    const appendixTable = {
      margin: [0, 0, 0, 0],
      table: {
        widths: [497],
        headerRows: 1,
        body: [],
        dontBreakRows: false
      },
      layout: {
        hLineWidth: function(i, node) {
          return 1;
        },
        vLineWidth: function(i, node) {
          return 1;
        },
        hLineColor: function(i, node) {
          return "#C9C9C9";
        },
        vLineColor: function(i, node) {
          return "#C9C9C9";
        },
        fillColor: function(i, node) {
          return i < node.table.headerRows ? "#eeeeee" : "white";
        },
        paddingBottom: function(i, node) {
          return 0;
        },
        paddingTop: function(i, node) {
          return 0;
        }
      }
    };

    // Table header
    appendixTable.table.body.push([
      {
        text: "New Suggested Controls and Risk Specific Guidelines/Tips",
        style: "tableSubTitle"
      }
    ]);

    // Add the suggested/appendix tips (if any exist)
    if (hasSuggestedTips || hasAppendixTips) {
      if (hasSuggestedTips) {
        // Row for selected Suggested Tips (custom)
        appendixTable.table.body.push([
          {
            stack: this.generateSectionSuggestedTips(suggestedTips),
            margin: [13, 2, 13, 10]
          }
        ]);
      }

      if (hasAppendixTips) {
        // Row for selected Appendix tips
        appendixTable.table.body.push([
          {
            stack: this.generateSectionAppendixTips(checkedAppendixTips),
            margin: [13, 2, 13, 10]
          }
        ]);
      }
    } else {
      // Display a message if none were selected
      appendixTable.table.body.push([
        {
          text: "No Guidelines/Tips Added",
          style: "empty"
        }
      ]);
    }

    // Generate comment table
    const commentsHeader = {
      text: "Comments",
      style: "tableSubTitle"
    };
    const commentsBody = comment && comment.trim().length > 0
      ? {
          text: comment.trim(),
          margin: [13, 10, 13, 10]
        }
      : {
          text: "No Comments",
          style: "empty"
        };

    const commentsTable = {
      margin: [0, 0, 0, 0],
      table: {
        widths: [497],
        headerRows: 1,
        body: [[commentsHeader], [commentsBody]],
        dontBreakRows: false
      },
      layout: {
        hLineWidth: function(i, node) {
          return 1;
        },
        vLineWidth: function(i, node) {
          return 1;
        },
        hLineColor: function(i, node) {
          return "#C9C9C9";
        },
        vLineColor: function(i, node) {
          return "#C9C9C9";
        },
        fillColor: function(i, node) {
          return i < node.table.headerRows ? "#eeeeee" : "white";
        }
      }
    };

    return [sectionTable, appendixTable, commentsTable];
  }

  header(currentPage, pageCount) {
    return [
      {
        stack: [
          {
            text: "Community Care Violence Assessment",
            style: "docTitle",
            margin: [0, 35, 0, 0],
            alignment: "left"
          },
          {
            text: this.headerSubtitle,
            style: "sectionTitle",
            margin: [0, 5, 0, 0],
            alignment: "left"
          },
          {
            table: {
              body: [[{ text: " ", border: [false, true, false, false] }]],
              widths: [496]
            },
            layout: {
              hLineColor: function(i, node) {
                return "#012345";
              },
              hLineWidth: function(i, node) {
                return 20;
              },
              vLineWidth: function(i, node) {
                return 2;
              },
              vLineColor: function(i, node) {
                return "#012345";
              }
            },
            margin: [0, 10, 0, 0]
          }
        ],
        margin: [40, 0, 0, 0]
      }
    ];
  }

  footer(currentPage, pageCount) {
    return [
      {
        table: {
          widths: [500],
          headerRows: 1,
          body: [[{ text: "", border: [false, true, false, false] }]]
        },
        layout: {
          hLineWidth: function(i, node) {
            return 1;
          },
          vLineWidth: function(i, node) {
            return 0;
          }
        },
        margin: [40, 20, 0, 0]
      },
      {
        text: "© Copyright 2017, Public Services Health and Safety Association. All rights reserved. Reproduction in whole or in part by any means without express written consent of Public Services Health and Safety Association is prohibited by law.",
        margin: [40, 0, 40, 0],
        style: "smallText"
      },
      {
        text: `${currentPage.toString()} of ${pageCount} pages`,
        margin: [0, 5, 40, 0],
        alignment: "right",
        style: "smallText",
        bold: true
      }
    ];
  }

  // Generate left cell for each risk (containing risk question, appendix tips and suggested controls)
  // Right cell is not generated from here but from getRiskAnswer function
  generateRiskInfo(risk) {
    let retStack = [];

    //risk question
    retStack.push({
      text: risk.question
    });

    /*eslint array-callback-return: "off" */
    if (risk.isRisk) {
      // if it is an indicated risk, then render suggested controls and tips risk suggested control
      const suggestedControlUL = risk.suggestedTips.map(tip => {
        if (tip.isChecked) {
          // Add references section to tip text
          return tip.references.length > 0
            ? `${tip.text} (${tip.references.join(", ")})`
            : tip.text;
        }
      });

      if (suggestedControlUL.length > 0) {
        retStack.push({
          text: "Suggested Controls:",
          style: "tableAppendixTitle"
        });
        retStack.push({
          ul: suggestedControlUL,
          style: "tableAppendixNormalText"
        });
      }
    }

    return retStack;
  }

  // Get the answer for risk.question knowing:
  // - is it a risk (risk.isRisk)
  // - which answer indicates risk (risk.whichIsRisk)
  getRiskAnswer(whichIsRisk, isRisk) {
    let answer = "";
    if (whichIsRisk === "y") {
      if (isRisk) answer = "Yes";
      else answer = "No";
    } else {
      if (isRisk) answer = "No";
      else answer = "Yes";
    }
    return answer;
  }

  /**
   * Generate the custom suggested tips from a section
   * @param  {array} tips List of custom suggested tips from a section
   * @return {array}      Generated document fragment
   */
  generateSectionSuggestedTips(tips) {
    const retStack = [];

    if (tips.length > 0) {
      retStack.push({
        text: "New Suggested Controls",
        style: "tableAppendixTitle"
      });

      // Add the section's suggested tips
      retStack.push({
        ul: tips,
        style: "tableAppendixNormalText"
      });
    }

    return retStack;
  }

  /**
   * Generate the selected appendix tips from a section
   * @param  {array} checkedAppendixTips List of selected appendix tips from a section
   * @return {array}                     Generated document fragment
   */
  generateSectionAppendixTips(checkedAppendixTips) {
    let retStack = [];

    const appendices = checkedAppendixTips;

    // Handle each appendix section
    Object.keys(appendices).forEach((aKey, aIndex) => {
      const subAppendices = appendices[aKey];
      let sectHasTip = false;
      let tempStack = [];

      // Handle each appendix subsection
      Object.keys(subAppendices).forEach((sKey, sIndex) => {
        let currentSubAppendix = subAppendices[sKey]; // array of selected tips inside the section. This only contains reference to the appendix data
        let currentSub = appendix[aKey].sections[sKey]; // this is the appendix data.
        let tipsUL = [];
        let subHasTip = false;

        for (var i = 0; i < currentSubAppendix.length; i++) {
          sectHasTip = true;
          subHasTip = true;
          let referenceToTip = currentSubAppendix[i];
          tipsUL.push(currentSub.tips[referenceToTip]);
        }

        // Add appendix subsection IF the subsection had a tip selected
        if (subHasTip) {
          if (currentSub.subTitle) {
            tempStack.push({
              text: currentSub.subTitle,
              style: "tableAppendixSubTitle"
            });
          }

          // Add the subsection list of selected tips
          tempStack.push({
            ul: tipsUL,
            style: "tableAppendixNormalText"
          });
        }
      });

      // Add appendix section IF the section had a tip selected
      if (sectHasTip) {
        retStack.push({
          text: `${aKey.toUpperCase()}. ${appendix[aKey].title}:`,
          style: "tableAppendixTitle"
        });

        retStack = retStack.concat(tempStack);
      }
    });

    return retStack;
  }

  // general styling for pdf pages
  getBaseTemplate() {
    return {
      footer: this.footer.bind(this),
      header: this.header.bind(this),
      pageMargins: [40, 110, 40, 80],
      content: [],
      styles: this.getStyles(),
      defaultStyle: {
        font: "gotham",
        fontSize: 10
      }
    };
  }

  // Specific styles for texts in each section
  getStyles() {
    return {
      docTitle: {
        fontSize: 16,
        bold: true
      },
      sectionTitle: {
        fontSize: 14
      },
      subTitle: {
        fontSize: 11,
        bold: true
      },
      tableTitle: {
        fontSize: 12,
        bold: true,
        margin: [13, 10, 13, 10]
      },
      tableSubTitle: {
        fontSize: 11,
        bold: true,
        margin: [13, 10, 13, 10]
      },
      tableAppendixTitle: {
        fontSize: 9,
        bold: true,
        margin: [0, 8, 0, 0]
      },
      tableAppendixSubTitle: {
        fontSize: 8,
        bold: true,
        margin: [0, 5, 0, 0]
      },
      tableAppendixNormalText: {
        fontSize: 8,
        bold: false,
        margin: [0, 4, 0, 0]
      },
      smallText: {
        fontSize: 8
      },
      empty: {
        margin: [13, 10, 13, 10],
        italics: true,
        color: "#939598"
      }
    };
  }
}

// this function initiates the fonts and images needed for pdf generator.
// We should use this function when loading a relatively big file (>10KB).
// getFontsForPdf is eventually called in src/index.js
function getFontsForPdf() {
  if (!pdfMake) {
    return;
  }
  pdfMake.vfs = {
    "Gotham-Book.otf": GothamBook,
    "Gotham-Medium.otf": GothamMedium,
    "Gotham-Bold.otf": GothamBold,
    "Gotham-BookItalic.otf": GothamItalic
  };
  pdfMake.fonts = {
    gotham: {
      normal: "Gotham-Book.otf",
      bold: "Gotham-Medium.otf",
      italics: "Gotham-BookItalic.otf",
      bolditalics: "Gotham-Bold.otf"
    }
  };
  let promisedImages = [];
  let addFile = res => (pdfMake.vfs[res.key] = res.file);
  for (let key in pdfMake.vfs) {
    promisedImages.push(fetchFile(pdfMake.vfs[key], key).then(addFile));
  }
  return Promise.all(promisedImages);
}

// Called from downloadPdf and printPdf
function generatePdf(section) {
  let template = new PdfTemplate();
  let dd = template.generateDocument(section);
  try {
    return pdfMake.createPdf(dd);
  } catch (err) {
    console.error(
      "PDF generation failed. Fonts for pdf probably not loaded yet."
    );
    console.error(err);
  }
}

// call generatePdf and download the generated content
function downloadPdf(section, filename) {
  let now = new Date();
  filename =
    filename || `${now.getFullYear()}${now.getMonth() + 1}${now.getDay()}.pdf`;

  generatePdf(section).download(filename);
}

// call generatePdf and pop up a print-preview window
// This will be blocked by most adBlock apps
function printPdf(section) {
  let now = new Date();
  let filename = `${now.getFullYear()}${now.getMonth() + 1}${now.getDay()}.pdf`;
  let pdf = generatePdf(section);
  if (navigator.msSaveOrOpenBlob) {
    // IE10 can't do a[download], only Blobs:
    pdf.getBlob(blob => {
      navigator.msSaveOrOpenBlob(blob, filename);
    });
  } else {
    pdf.print();
  }
}

export { PdfTemplate, getFontsForPdf, downloadPdf, printPdf };



// WEBPACK FOOTER //
// ./src/common/pdf/documentTemplate.jsx